import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";
import { useFormContext } from "react-hook-form";

function F001Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const { watch } = useFormContext();
  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  const isQ001A010Checked = Boolean(watch(`${sectionDelimiter}Q001A010`));
  const isQ001A011Checked = Boolean(watch(`${sectionDelimiter}Q001A011`));
  const isQ001A012Checked = Boolean(watch(`${sectionDelimiter}Q001A012`));
  const isQ001A013Checked = Boolean(watch(`${sectionDelimiter}Q001A013`));
  const isQ001A014Checked = Boolean(watch(`${sectionDelimiter}Q001A014`));

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="Ankle"
          showAuditsBtn={false}
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Ankle"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement
                label="L"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="R"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="lat malleous"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="med malleous"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="bimalleolar"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                label="trimalleolar"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A007`}
                type="cross-option"
              />
              <ChartRowElement
                label="distal tibial pilon"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                label="SH:"
                name={`${sectionDelimiter}Q001A009`}
                type="cross-option"
              />
              <ChartRowElement
                label="1"
                name={`${sectionDelimiter}Q001A010`}
                type="cross-option"
                isDisabled={
                  isQ001A011Checked ||
                  isQ001A012Checked ||
                  isQ001A013Checked ||
                  isQ001A014Checked
                }
              />
              <ChartRowElement
                label="2"
                name={`${sectionDelimiter}Q001A011`}
                type="cross-option"
                isDisabled={
                  isQ001A010Checked ||
                  isQ001A012Checked ||
                  isQ001A013Checked ||
                  isQ001A014Checked
                }
              />
              <ChartRowElement
                label="3"
                name={`${sectionDelimiter}Q001A012`}
                type="cross-option"
                isDisabled={
                  isQ001A010Checked ||
                  isQ001A011Checked ||
                  isQ001A013Checked ||
                  isQ001A014Checked
                }
              />
              <ChartRowElement
                label="4"
                name={`${sectionDelimiter}Q001A013`}
                type="cross-option"
                isDisabled={
                  isQ001A010Checked ||
                  isQ001A011Checked ||
                  isQ001A012Checked ||
                  isQ001A014Checked
                }
              />
              <ChartRowElement
                label="5"
                name={`${sectionDelimiter}Q001A014`}
                type="cross-option"
                isDisabled={
                  isQ001A010Checked ||
                  isQ001A011Checked ||
                  isQ001A012Checked ||
                  isQ001A013Checked
                }
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A015`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="nondisplaced"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A016`}
                type="cross-option"
              />
              <ChartRowElement
                label="displaced"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A017`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A018`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F001Interpretation };
